/**
 * Backend URL resolver.
 *
 * Build-time `REACT_APP_BACKEND_URL` is set by Emergent's deploy pipeline
 * to the auto-generated `*.emergent.host` URL — which is a *different
 * origin* from the user's custom domain. That breaks CORS preflights and
 * `SameSite=lax` httpOnly cookies in the browser.
 *
 * Runtime-detect known production hostnames and use empty base (relative
 * URLs → same-origin) so `/api/*` resolves through the same domain the
 * user is on. In dev / preview the build-time value is used.
 */
const SAME_ORIGIN_HOSTS = new Set(['tune4tune.com', 'www.tune4tune.com']);

export const BACKEND_URL = (() => {
  if (typeof window !== 'undefined' && SAME_ORIGIN_HOSTS.has(window.location.hostname)) {
    return '';
  }
  return process.env.REACT_APP_BACKEND_URL || '';
})();
